// Comma-format an integer string using regex — no Number() roundtrip,
// so 22+ digit values keep their exact form.
const formatLongIntegerString = (digits: string): string =>
  digits.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const formatNumberWithCommas = (value: string | number): string => {
  if (value === null || value === undefined || value === '') return '';

  const raw = String(value).replace(/,/g, '');

  // Any alphabet → treat as free text
  if (/[a-zA-Z]/.test(raw)) {
    return raw;
  }

  // Numeric only (allow decimal)
  if (!/^\d*\.?\d*$/.test(raw)) {
    return raw;
  }

  // Integers go through the regex formatter — no Number() roundtrip,
  // so values past Number.MAX_SAFE_INTEGER keep their exact form. The
  // bug this fixes (TCX-356): Number('9999999999999999') rounds to
  // 1e16, and `toLocaleString` flips to scientific notation for
  // anything ≥ 1e21. The CashRequiredInput controlled-input pipeline
  // then re-renders with the scientific form on every keystroke, so
  // backspace can't make progress — the value snaps back to the
  // precision-lost form. The string formatter avoids both issues.
  // codex review caught the original boundary at 16-digit values
  // above MAX_SAFE_INTEGER (e.g. '9999999999999999').
  if (!raw.includes('.')) {
    return formatLongIntegerString(raw);
  }

  const num = Number(raw);
  if (Number.isNaN(num)) return raw;

  return num.toLocaleString('en-US');
};

export const stripCommas = (v: unknown): string =>
  v === null || v === undefined ? '' : String(v).replace(/,/g, '');
